import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-[#0E5C3A] text-[#F4D4DC] font-baseRegular relative">
      {/* Section principale */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo + infos */}
          <div className="lg:col-span-2">
            <div className="flex items-start space-x-6">
              <div className="flex-shrink-0">
                <img
                  src="/assets/logos/Logo_Felicita_rose.webp"
                  alt="Felicità Festival Logo"
                  className="w-24 h-auto"
                />
              </div>
              <div>
                <p className="bg-[#0E5C3A] text-[#FFFFFF] text-lg mb-4 font-medium px-3 py-1 rounded inline-block">
                  Concerts, ateliers et fouées
                </p>
                <div className="space-y-3 text-[#F4D4DC]">
                  <div className="flex items-center space-x-3">
                    <span className="text-[#F0A5B8] text-lg">📅</span>
                    <span className="font-medium">Samedi 29 août 2026</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <span className="text-[#F0A5B8] text-lg">📍</span>
                    <span className="font-medium">Brissac-Quincé - 49320</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xl font-bold mb-6 bg-[#0E5C3A] text-[#FFFFFF] px-3 py-1 rounded">
              Navigation
            </h4>
            <ul className="space-y-3">
              {[
                { href: "/", label: "Accueil" },
                { href: "/infospratiques", label: "Infos Pratiques" },
                { href: "/programmation", label: "Programmation" },
                { href: "/billetterie", label: "Billetterie" },
                { href: "/contact", label: "Contact" },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-[#F4D4DC] hover:text-[#F0A5B8] transition-colors duration-200 hover:translate-x-1 transform block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Réseaux sociaux */}
          <div>
            <h4 className="text-xl font-bold mb-6 bg-[#0E5C3A] text-[#FFFFFF] px-3 py-1 rounded">
              Suivez-nous
            </h4>
            <div className="flex justify-center space-x-6 mb-8">
              <a
                href="https://www.instagram.com/lafelicitafestival"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram du festival"
                className="bg-[#F0A5B8] p-4 rounded-full shadow-md hover:shadow-lg transition-all hover:scale-105"
              >
                <svg
                  className="w-7 h-7 text-pink-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.791-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>

              <a
                href="https://www.facebook.com/lafelicitafestival"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook du festival"
                className="bg-[#F0A5B8] p-4 rounded-full shadow-md hover:shadow-lg transition-all hover:scale-105"
              >
                <svg
                  className="w-7 h-7 text-blue-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-[#F4D4DC]/30">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center text-sm text-[#F4D4DC]">
          <div>© 2026 Felicità Festival. Tous droits réservés.</div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
